<template>
  <notifications
    group="app"
    width="22rem"
    position="bottom center"
    animation-type="velocity"
  >
    <template
      slot="body"
      slot-scope="props"
    >
      <div
        class="relative bg-white p-3 pr-6 mb-2 border-l-4 text-primary text-2xs font-medium"
        :class="`border-${props.item.type}`"
        @click="props.close"
      >
        <span>
          {{ props.item.title }}
        </span>
        <decline class="absolute top-2 right-2 w-3 h-3" />
        <div
          class="text-light"
          v-html="props.item.text"
        />
      </div>
    </template>
  </notifications>
</template>

<script>
import Decline from '@/icons/Decline.vue'
export default {
  name: 'NotificationWrapper',
  components: {
    Decline
  }
}
</script>

<style lang="scss">
.vue-notification-group {
  left: 50%;
  transform: translateX(-50%);
  @apply mt-4;
}
</style>
